import { DataTableColumnHeader } from "@components/ui/data-table/DataTableColumnHeader";
import { formatDateShort } from "@/lib/format";
import { createColumn } from "@/lib/table/columnFactory";
import type { Ticket, TicketColumnSettings } from "./types";

export const createdAtColumnFactory = (settings: TicketColumnSettings) =>
  createColumn<Ticket>({
    id: "createdAt",
    accessorKey: "createdAt",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Créé le" />,
    cell: ({ row }) => (
      <time
        dateTime={row.original.createdAt}
        className={`${settings.cellText} text-base-content/60`}
      >
        {formatDateShort(row.original.createdAt)}
      </time>
    ),
    size: 110,
  });
